import React from 'react'
import { AuthorCard } from './components/cards/AuthorCard'
import { Tag } from './components/extra/Tag'
import { articleType } from './components/article'

type Props = {
  item: articleType
  isExtended: boolean
  extendClick: () => void
  extendButtonRef: React.RefObject<HTMLDivElement>
}

export const ArticleContent = ({
  item,
  isExtended,
  extendClick,
  extendButtonRef,
}: Props) => (
  <div
    className='flex flex-col 
        px-[22px] sm:px-[40px] md:px-[80px] xl:px-[40px] 2xl:px-[110px] 
        py-[60px] sm:py-[70px] md:py-[80px] xl:py-[90px] 2xl:py-[110px] 
        gap-[60px]'
  >
    <div
      className='flex 
          flex-col items-center 
          xl:grid xl:grid-cols-[auto_439px] xl:items-start 
          gap-[60px] xl:gap-[40px] 2xl:gap-[60px]'
    >
      <div
        className='max-w-[1100px] border-[#BBD2D7] 
          border-l-[4px] md:border-l-[10px] 
          pl-3 md:pl-6'
      >
        <div className='text-[#001A3D] text-lg md:text-[32px] font-bold tracking-wide'>
          {item.title}
        </div>

        <p className='text-justify text-[#586885] font-normal leading-6 tracking-wide mb-10'>
          {item.caption}
        </p>

        <div
          className={`overflow-clip text-justify text-[#586885] font-normal leading-6 tracking-wide mb-10 mt-10 space-y-[10px]
              ${isExtended ? 'h-auto' : 'h-[1000px] md:h-auto'}
            }`}
          dangerouslySetInnerHTML={{
            __html: item?.content?.replace(/&lt;meta charset="UTF-8"&gt;/g, ''),
          }}
        />

        <div className='flex justify-end md:hidden' ref={extendButtonRef}>
          <button
            onClick={extendClick}
            className='text-xs text-[#001A3D] underline font-medium'
          >
            {isExtended ? 'Show less' : 'Show more'}
          </button>
        </div>
      </div>

      <div className='flex flex-col gap-10 min-w-[319px]'>
        <AuthorCard
          authorName={item.author.name}
          publishDate={item.publish_date}
          updatedDate={item.updated_at}
          dark={true}
        />

        <div className='flex flex-wrap gap-3 xl:gap-4'>
          {item?.tags?.map((tag, idx) => (
            <Tag
              key={tag + idx}
              text={tag}
              className='font-medium
                    text-xs md:text-sm xl:text-base 
                    px-[6px] md:px-[8px]
                    py-[2px] md:py-[4px]'
            />
          ))}
        </div>
      </div>
    </div>
  </div>
)
